import projects from './projects.json';

export interface ProjectDataTemplate {
    Name: string;
    Src: string;
    Alt: string;
}

export const ProjectData: Record<string, ProjectDataTemplate> = projects;
